import { render, staticRenderFns } from "./SearchTableHeaderSorting.vue?vue&type=template&id=30a9a257&scoped=true&"
import script from "./SearchTableHeaderSorting.vue?vue&type=script&lang=ts&"
export * from "./SearchTableHeaderSorting.vue?vue&type=script&lang=ts&"
import style0 from "./SearchTableHeaderSorting.vue?vue&type=style&index=0&id=30a9a257&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a9a257",
  null
  
)

export default component.exports